import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './styles/primitives.css';
import './styles/institutionalUi.css';
import './styles/dashboard.css';
import './styles.css';
import App from './App';
import './styles/redesign.css';
import './styles/corporateFeeds.css';
import './styles/earningsAlert.css';
import './styles/shell.css';
import './styles/darkTheme.css';
import './styles/marketMtfModal.css';
import './styles/filterDrawer.css';
import './styles/accumulationLadder.css';
import './styles/kiteTrade.css';
import './styles/commandPalette.css';
import './styles/diwaliTheme.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
